/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $border = $el.find('.border');

TweenMax.to($border, 22, {
    rotation: 360,
    ease: Linear.easeNone,
    repeat: -1
});
